export default __webpack_public_path__ + "img/atom.250da555.svg";